import React from 'react';

import { ModuleOnboardingChips } from '@vyce/core/src/components/ModuleOnboardingChips';
import { WorkerPickerRow } from '@vyce/core/src/components/WorkerPickerRow';
import { CompanyWorkerItem } from '@vyce/core/src/types';

interface Props {
  worker: CompanyWorkerItem;
  checked: boolean;
  onToggle: () => void;
}

// Existing users are addressed by user_id, so a missing phone or email never blocks them.
// Module chips carry the same onboarding state as the User Management list.
export const ExistingUserRow: React.FC<Props> = ({ worker, checked, onToggle }) => (
  <WorkerPickerRow
    worker={worker}
    checked={checked}
    onToggle={onToggle}
    meta={
      worker.modules?.length ? (
        <ModuleOnboardingChips modules={worker.modules} onboarding={worker.onboarding} />
      ) : undefined
    }
  />
);
